import Vue, { PropType } from "vue";
import { ICell } from "js/crossword/types";

import style from "../css/BoardCell.module.css";

export default Vue.extend({
  props: {
    cell: Object as PropType<ICell>,
    enlarge: Boolean,
    puzzleColumns: Number,
    puzzleRows: Number,
  },
  methods: {
    resizeClueText(): void {
      const cellContainer = this.$refs.cellContainer as HTMLElement;
      const cluesContainer = this.$refs.cluesTextContainer as HTMLElement;

      let fontSize = 1;
      cluesContainer.style.fontSize = `${fontSize}em`;

      while (cellContainer.scrollHeight > cellContainer.clientHeight) {
        cluesContainer.style.fontSize = `${fontSize}em`;
        fontSize -= 0.01;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeClueText();
    });
  },
  render() {
    const arrow = this.cell.arrow || [];

    return (
      <div class={style.container} ref="cellContainer">
        <div class={style.arrowWrapper} ref="cluesTextContainer">
          { this.enlarge
            ? <EnlargedClue
                cell={this.cell}
                puzzleColumns={this.puzzleColumns}
                puzzleRows={this.puzzleRows}
              />
            : null }
            
          { arrow.map((clue, index) => (
            <div class={style.arrowContent}>
              { index > 0 && index <= arrow.length ? <div class={style.clueSeparator}></div> : null }
              <div
                class={style.clueText}
                onClick={() => this.$emit("clueClicked", clue.clueId)}
                lang="de"
              >
                { clue.clueText }
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
});

const EnlargedClue = Vue.extend({
  props: {
    cell: Object as PropType<ICell>,
    puzzleColumns: Number,
    puzzleRows: Number,
  },
  methods: {
    getEnlargePosition(): { x: string, y: string } {
      const { x, y } = this.cell;
      const maxX = this.puzzleColumns - 1;
      const maxY = this.puzzleRows - 1;
      
      // Top-Left
      if (x === 0 && y === 0) return { x: "0%", y: "0%" };
      // Top-Right
      if (x === maxX && y === 0) return { x: "100%", y: "0%" };
      // Bottom-Left
      if (x === 0 && y === maxY) return { x: "0%", y: "100%" };
      // Bottom-Right
      if (x === maxX && y === maxY) return { x: "100%", y: "100%" };
      // Center-Left
      if (x === 0) return { x: "0%", y: "50%" };
      // Center-Right
      if (x === maxX) return { x: "100%", y: "50%" };
      // Center-Top
      if (y === 0) return { x: "50%", y: "0%" };
      // Center-Bottom
      if (y === maxY) return { x: "50%", y: "100%" };
      
      // Center
      return { x: "50%", y: "50%" };
    },
  },
  render() {
    const arrow = this.cell.arrow || [];
    const { x, y } = this.getEnlargePosition();
    return (
      <div
        class={style.enlargeWrapper}
        style={{ left: x, top: y }}
      >
        { arrow.map(clue => (
          <div
            class={style.enlarge}
            style={{ transform: `translate(-${x}, -${y})` }}
          >
            { clue.clueText }
          </div>
        )) }
      </div>
    );
  }
});
